/* RESPONSIBLE TEAM: team-messenger */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class Sales extends Controller {
  queryParams = [{ style: { type: 'string' as const } }];

  @tracked style: string | null = null;
}
